import React from 'react';
// import { useSelector } from 'react-redux';

const FutureMetricCard = ({ data = [], loading = false, width = '100%', height = 'auto', maxWidth = '416px', maxHeight = '287px' }) => {
  // const currentDate = useSelector((state) => state.customization.currentDate);
  // const formattedDate = typeof currentDate === 'string' ? currentDate.split('T')[0] : new Date(currentDate).toISOString().split('T')[0];

  // Use passed data or fallback to empty array
  const idleManPower = Array.isArray(data) ? data : [];
  const totalIdleCount = idleManPower.reduce((sum, item) => sum + (item.count || 0), 0);

  // Future Metrics Header SVG (52x52)
  const FutureMetricHeaderSVG = ({ size = 52 }) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 52 52"
      fill="none"
      style={{ width: 52, height: 52, flexShrink: 0, aspectRatio: '1 / 1' }}
    >
      <path d="M26 4.33337C14.4 4.33337 5.20001 13.5334 5.20001 25.1334C5.20001 36.7334 14.4 45.9334 26 45.9334C37.6 45.9334 46.8 36.7334 46.8 25.1334C46.8 13.5334 37.6 4.33337 26 4.33337ZM26 41.6C16.8 41.6 9.53334 34.3334 9.53334 25.1334C9.53334 15.9334 16.8 8.66671 26 8.66671C35.2 8.66671 42.4667 15.9334 42.4667 25.1334C42.4667 34.3334 35.2 41.6 26 41.6Z" fill="#9C27B0"/>
      <path d="M24.8333 15.1667H27.1667V27.4667L36.8333 32.5L35.6667 34.4333L24.8333 28.6V15.1667Z" fill="#9C27B0"/>
      <circle cx="26" cy="25.1334" r="2.16667" fill="#9C27B0"/>
    </svg>
  );

  // Future Metrics Stat SVG (24x24)
  const FutureMetricStatSVG = ({ size = 24 }) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      style={{ width: 24, height: 24, flexShrink: 0, aspectRatio: '1 / 1' }}
    >
      <path d="M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM12 20C7.59 20 4 16.41 4 12C4 7.59 7.59 4 12 4C16.41 4 20 7.59 20 12C20 16.41 16.41 20 12 20Z" fill="#9C27B0"/>
      <path d="M11 7H13V13L17 15.5L16 17L11 14V7Z" fill="#9C27B0"/>
    </svg>
  );

  // Skeleton Loader
  const SkeletonLoader = () => (
    <>
      <div
        style={{
          width: '100%',
          height: 110,
          borderRadius: 18,
          background: 'linear-gradient(180deg, rgba(255,255,255,0.08), rgba(255,255,255,0.04))',
          outline: '1px solid rgba(120,153,255,0.15)',
          marginBottom: 24
        }}
      />
      <div style={{ width: '24%', height: 26, backgroundColor: 'rgba(255,255,255,0.10)', borderRadius: 6, marginBottom: 10 }} />
      <div style={{ width: '36%', height: 22, backgroundColor: 'rgba(255,255,255,0.08)', borderRadius: 6, marginBottom: 10 }} />
      <div style={{ width: '30%', height: 22, backgroundColor: 'rgba(255,255,255,0.08)', borderRadius: 6 }} />
    </>
  );

  // Header Pill
  const HeaderPill = () => (
    <div
      style={{
        position: 'relative',
        width: '100%',
        height: 'clamp(90px, 12vw, 103px)',
        borderRadius: 18,
        padding: 'clamp(12px, 3vw, 20px)',
        display: 'flex',
        alignItems: 'center',
        color: '#fff',
        overflow: 'hidden',
        background: 'linear-gradient(180deg, rgba(20,31,74,0.9) 0%, rgba(12,18,48,0.9) 100%)',
        boxShadow: 'inset 0 0 0 1px rgba(86,129,255,0.55), 0 8px 22px rgba(0,0,0,0.35)'
      }}
    >
      {/* Slanted overlay */}
      <div
        style={{
          position: 'absolute',
          right: '-20%',
          top: 0,
          bottom: 0,
          width: '70%',
          transform: 'skewX(-18deg)',
          background: 'linear-gradient(180deg, rgba(7,12,32,0.65) 0%, rgba(7,12,32,0.2) 100%)',
          filter: 'blur(0.2px)'
        }}
      />

      {/* Left: Title + count */}
      <div style={{ position: 'relative', zIndex: 2, flex: 1, minWidth: 0 }}>
        <div style={{ 
          fontSize: 'clamp(14px, 2.5vw, 16px)', 
          fontWeight: 600, 
          marginBottom: 6,
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          whiteSpace: 'nowrap'
        }}>Future Metrics</div>

        <div style={{ display: 'flex', alignItems: 'baseline', gap: 8, minWidth: 0 }}>
          <div style={{ 
            fontSize: 'clamp(28px, 6vw, 40px)', 
            fontWeight: 300, 
            lineHeight: 1,
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap'
          }}>{totalIdleCount}</div>
          <div style={{ 
            fontSize: 'clamp(10px, 2vw, 12px)', 
            opacity: 0.8,
            flexShrink: 0
          }}>Idle Workers</div>
        </div>
      </div>

      {/* Right: responsive icon */}
      <div
        style={{
          position: 'absolute',
          right: 'clamp(12px, 3vw, 18px)',
          top: '50%',
          transform: 'translateY(-50%)',
          zIndex: 3,
          flexShrink: 0
        }}
      >
        <FutureMetricHeaderSVG size={window.innerWidth < 480 ? 36 : 52} />
      </div>
    </div>
  );

  // Stats Row
  const StatRow = ({ icon, value, label, isLast }) => (
    <div>
      <div style={{ display: 'flex', alignItems: 'center', gap: 'clamp(8px, 2vw, 12px)', marginBottom: 10 }}>
        <div
          style={{
            width: 'clamp(32px, 5vw, 36px)',
            height: 'clamp(32px, 5vw, 36px)',
            borderRadius: '50%',
            background: 'rgba(86,129,255,0.18)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            outline: '1px solid rgba(86,129,255,0.35)',
            flexShrink: 0
          }}
        >
          {icon}
        </div>

        <div style={{ display: 'flex', alignItems: 'baseline', gap: 10, minWidth: 0, flex: 1 }}>
          <span style={{ 
            fontSize: 'clamp(18px, 3.5vw, 22px)', 
            fontWeight: 800,
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap'
          }}>{value}</span>
          <span style={{ 
            fontSize: 'clamp(11px, 2vw, 13px)', 
            color: 'rgba(226,232,240,0.7)',
            flexShrink: 0
          }}>{label}</span>
        </div>
      </div>

      {!isLast && <div style={{ margin: '14px 0', height: 1, backgroundColor: 'rgba(255,255,255,0.06)' }} />}
    </div>
  );

  return (
    <div
      style={{
        position: 'relative',
        width: width,
        height: height,
        maxWidth: maxWidth,
        maxHeight: maxHeight,
        minWidth: '280px',
        borderRadius: 20,
        background: 'linear-gradient(127deg, rgba(6,11,40,0.94) 19.41%, rgba(10,14,35,0.49) 76.65%)',
        backdropFilter: 'blur(60px)',
        WebkitBackdropFilter: 'blur(60px)',
        padding: 'clamp(16px, 4vw, 24px)',
        color: '#fff',
        overflow: 'hidden',
        boxShadow: '0 12px 28px rgba(0,0,0,0.45)',
        fontFamily:
          'ui-sans-serif, system-ui, -apple-system, Segoe UI, Roboto, "Helvetica Neue", Arial, "Noto Sans", "Apple Color Emoji", "Segoe UI Emoji"'
      }}
    >
      {loading ? (
        <SkeletonLoader />
      ) : (
        <>
          <HeaderPill />

          {/* STATISTICS */}
          <div style={{ marginTop: 'clamp(14px, 3vw, 18px)' }}>
            <div
              style={{
                fontSize: 'clamp(10px, 2vw, 12px)',
                letterSpacing: '1.4px',
                color: 'rgba(226,232,240,0.75)',
                marginBottom: 10
              }}
            >
              STATISTICS
            </div>

            <div
              style={{
                height: 'clamp(120px, 20vw, 140px)',
                overflowY: 'auto',
                paddingRight: 8,
                scrollbarWidth: 'thin',
                scrollbarColor: 'rgba(255,255,255,0.3) rgba(255,255,255,0.08)'
              }}
            >
              <StatRow
                icon={<FutureMetricStatSVG />}
                value={totalIdleCount}
                label="Total Idle Count"
                isLast
              />
            </div>
          </div>
        </>
      )}

      {/* Soft radial glow */}
      <div
        style={{
          position: 'absolute',
          top: '-40%',
          right: '-20%',
          width: 360,
          height: 360,
          borderRadius: '50%',
          background: 'radial-gradient(closest-side, rgba(255,255,255,0.06), rgba(255,255,255,0))',
          pointerEvents: 'none',
          filter: 'blur(2px)'
        }}
      />
    </div>
  );
};

export default FutureMetricCard;
